module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"search":"Je cherche un produit…"},"en":{"search":"I\u0027m looking for a product…"},"pt":{"search":"Procuro um produto…"},"es":{"search":"Busco un producto…"},"de":{"search":"Suchbegriff eingeben…"},"it":{"search":"Cerco un prodotto…"},"nl":{"search":"Ik zoek een product…"}}')
  delete Component.options._Ctor
}
